import React, { Fragment, useEffect } from 'react';

import PropTypes from 'prop-types';

import {
    Button,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import sadChiku from 'wanderu-assets/images/sad-chiku.svg';
import baseAppConfig from 'wanderu-shellapp/src/config/baseApp.locales';

import styles from './ErrorComponent.scss';

const ErrorTypes = {
    DEFAULT_ERROR: 'default-error',
    SUCCESS_UNAVAILABLE: 'success_unavailable',
};

const ErrorComponent = (props) => {
    const {
        errorType = ErrorTypes.DEFAULT_ERROR,
        onGoBack,
        onLoad,
        t,
    } = props;

    useEffect(() => {
        if (onLoad) {
            onLoad();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <div className={styles.container}>
            <img
                alt=""
                className={styles.sadChiku}
                id="sad-chiku"
                src={sadChiku}
            />
            {errorType === ErrorTypes.SUCCESS_UNAVAILABLE
                ? (
                    <Fragment>
                        <strong>{t('oh-no')}</strong>
                        <p>{t('livecheck-trip-not-available')}</p>
                    </Fragment>
                )
                : (
                    <Fragment>
                        <strong>{t('uh-oh')}</strong>
                        <p>{t('livecheck-error')}</p>
                    </Fragment>
                )}
            <Button
                className={styles.button}
                label={t('keep-searching')}
                onClick={onGoBack}
            >
                {t('keep-searching')}
            </Button>
        </div>
    );
};

ErrorComponent.propTypes = {
    errorType: PropTypes.oneOf(Object.values(ErrorTypes)),
    onGoBack: PropTypes.func.isRequired,
    onLoad: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export {
    ErrorComponent,
    ErrorTypes,
};

export default localize(ErrorComponent, baseAppConfig.namespace);
